import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import { useMaterialUIController } from "context";

export default function ClientCard({ client, onDelete, onEdit }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

    return (
        <MDBox
          p={3}
          mb={2}
          borderRadius="xl"
          bgColor={darkMode ? "dark" : "white"}
          shadow="md"
          sx={{ cursor: "pointer", position: "relative" }}
          onClick={() => onEdit(client)}
        >
            {/* 🗑️ DELETE */}
            <MDBox
                position="absolute"
                top={8}
                right={8}
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete(client);
                }}
            >
                <Icon color="error" fontSize="small">
                    delete
                </Icon>
            </MDBox>

            {/* 📇 DADOS */}
            <MDTypography fontWeight="bold">
                {client.name}
            </MDTypography>

            <MDTypography variant="caption">
                📞 {client.phone}
            </MDTypography>

            {client.email && (
                <MDTypography variant="caption">
                    ✉️ {client.email}
                </MDTypography>
            )}
        </MDBox>
    );

}
